<template>
  <v-layout
    wrap
    row>
    <v-flex
      xs12>
      <v-flex
        v-if="item.tiers && item.tiers.length"
        xs6
        class="pa-0"
      >
        <item-tiers-list
          :tier-prices="item.tiers"
          :quantity="item.quantity"
        />
      </v-flex>
      <v-flex
        xs6
        class="pa-0"
      >
        <item-tiers
          v-model="item.quantity"
          :tier-prices="item.tiers || []"
          small
        />
      </v-flex>
    </v-flex>
  </v-layout>
</template>

<script>
import ItemTiersList from '@/modules/Orders/components/Items/ItemTiersList'
import ItemTiers from '@/modules/Orders/components/Items/ItemTiers'

export default {
  name: 'ItemTierBreakdown',
  components: { ItemTiers, ItemTiersList },

  props: {
    item: {
      required: true,
      type: Object
    }
  }
}
</script>
